import {useEffect, useRef, useState} from "react";
import {
  Col,
  Form,
  Dropdown,
  DropdownButton,
  FormControl,
} from "react-bootstrap";
import Tooltip from "./Tooltip";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import INDIA_ETF from "../../../assets/Instruments/INDIA_ETF.json";
import INDIA_STOCK from "../../../assets/Instruments/INDIA_ETF.json";
import US_STOCK from "../../../assets/Instruments/10B_above_US.json";
import US_ETF from "../../../assets/Instruments/US_ETF.json";
import UK_LIST from "../../../assets/Instruments/LSE_ETF.json";
import nifty_data from "../../../assets/Instruments/nifty_data.json";
import SGX_LIST from "../../../assets/Instruments/SGX.json";

// Stock lists
const INDIA_LIST = [...INDIA_ETF, ...INDIA_STOCK, ...nifty_data];
const US_LIST = [...US_STOCK, ...US_ETF];
// console.log(INDIA_LIST);
// console.log(US_LIST);

// Set default values to specific props to avoid errors. Set default class 'class-placeholder' to avoid 'className cannot be empty' error

const SearchDropdown = ({
                          country,
                          label,
                          value,
                          placeholder,
                          name,
                          handleChange,
                          colClass = "class-placeholder",
                          errorMsg = "",
                          isValidate,
                          isFullWidth = false,
                          validateInput,
                          marginBottom = "",
                          hint = "",
                        }) => {
  const [allOptions, setAllOptions] = useState([]);
  const [optionsToShow, setOptionsToShow] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);
  const maxOptions = 20;
  useEffect(() => {
    let tempOptions = [];
    if (country === "India") {
      tempOptions = INDIA_LIST;
    } else if (country === "United States") {
      tempOptions = US_LIST;
    } else if (country === "United Kingdom") {
      tempOptions = UK_LIST;
    } else if (country === "Singapore") {
      tempOptions = SGX_LIST;
    }

    setAllOptions(tempOptions);
    setNewOptionsToShow(tempOptions);
  }, [country]);
  useEffect(() => {
    const matchingResults = allOptions.filter(option => {
      // filter brokers by the `search` first. if `search` variable
      // is empty - by default - then all brokers will be displayed
      const name = option.name?.toLowerCase();

      const symbol = option.symbol?.toLowerCase();
      const search = value.toLowerCase();
      if ((name && name.includes(search)) || symbol.includes(search))
        return option;
    });

    const bestMatch = matchingResults.map(item => ({
      ...item,
      match:
        item.symbol?.toLowerCase() === value.toLowerCase()
          ? "symbol"
          : "name" || "name",
    }));

    setNewOptionsToShow(bestMatch);
  }, [value, allOptions]);

  // Check is input focused
  useEffect(() => {
    const handleFocus = () => {
      setIsFocused(true);
    };

    const handleBlur = e => {
      const classname = e.target?.className;
      if (
        !classname.includes("dropdown-toggle") &&
        !classname.includes("dropdown-item")
      )
        setIsFocused(false);
    };

    // Add event listeners for focus and blur events
    if (inputRef.current) {
      inputRef.current.addEventListener("focus", handleFocus);
      window.addEventListener("click", handleBlur);
    }

    // Clean up event listeners when the component unmounts
    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener("focus", handleFocus);
        window.removeEventListener("click", handleBlur);
      }
    };
  }, []);
  const setNewOptionsToShow = allOptions => {
    setOptionsToShow(
      allOptions.length > maxOptions
        ? allOptions.slice(0, maxOptions)
        : allOptions
    );
  };
  const onChange = e => {
    // Event simulator object. Since this is custom select we cannot use event.target on it
    console.log(e);

    inputRef.current.focus();
    inputRef.current.blur();
    const event = {target: {name: name, value: e}};
    setIsFocused(false);
    handleChange(event);
  };

  return (
    <Form.Group
      as={Col}
      sm={12}
      lg={isFullWidth ? 12 : 6}
      className={`${
        marginBottom.length > 0 ? marginBottom : "mb-3"
      } ${colClass}`}
    >
      <Form.Label
        htmlFor={label.toLowerCase()}
        className={`d-flex ${label.length === 0 && "m-0"}`}
      >
        <small>{label} </small>
        {hint && <Tooltip text={hint}/>}
      </Form.Label>
      <Dropdown
        variant="custom"
        show={isFocused && optionsToShow.length !== 0}
        onSelect={onChange}
        value={value}
      >
        <DropdownToggle
          name={name}
          as={FormControl}
          placeholder={placeholder}
          onChange={handleChange}
          value={value}
          ref={inputRef}
          autoComplete="off"
          isInvalid={errorMsg ? true : false}
          className="custom-search-input"
        ></DropdownToggle>
        <Form.Control.Feedback type="invalid">
          {errorMsg ? errorMsg : "The field cannot be empty."}
        </Form.Control.Feedback>

        <DropdownMenu variant="custom" className="custom-dropdown">
          {optionsToShow.map((option, i) => (
            <Dropdown.Item
              variant="custom"
              className="p-3 custom-dropdown-item overflow-hidden text-truncate"
              eventKey={option.symbol}
              key={i}
            >
              <span className="d-none d-md-inline">
                {option?.symbol} {option?.name && `- ${option?.name}`}
              </span>
              <span className="d-md-none">{option[option.match]}</span>
            </Dropdown.Item>
          ))}
        </DropdownMenu>
      </Dropdown>
    </Form.Group>
  );
};

export default SearchDropdown;
